<template>
  <div>
    <BlockTitle :subtitle="subtitle" :title="title" />
    <RevCardCarousel
      :next-alternative-text="i18n(translations.alternativeNext)"
      :prev-alternative-text="i18n(translations.alternativePrevious)"
    >
      <RevCard
        v-for="review in reviews"
        :key="review.id"
        data-test="review-card"
      >
        <div class="relative h-400 w-256">
          <RevIllustration
            alt=""
            class="rounded-t-lg h-full w-full object-cover"
            data-test="review-card-image"
            :height="400"
            :src="review.reviewPictureUrl"
            :width="256"
          />

          <div
            class="absolute bottom-0 left-0 right-0 top-0 bg-gradient-to-b from-transparent to-[#1d2024]"
          ></div>

          <RevTag
            class="absolute left-16 top-16"
            :label="`${review.customer.firstName} ${review.customer.lastName}`"
            variant="secondary"
          />

          <div
            class="mood-inverse absolute bottom-16 left-16 right-16 flex flex-col gap-16"
          >
            <div class="text-static-default-hi body-2">
              {{ review.comment }}
            </div>

            <RevRating :score="review.averageRate" size="extra-small" />
          </div>
        </div>

        <div class="flex grow gap-16 p-16">
          <RevIllustration
            alt=""
            class="h-52 w-52"
            :height="52"
            sizes="52px"
            :src="review.product.imageUrl"
            :width="52"
          />

          <div class="text-static-default-hi caption">
            {{ review.product.title }}
          </div>
        </div>
      </RevCard>
    </RevCardCarousel>
  </div>
</template>

<script lang="ts" setup>
import type { Link } from '@backmarket/http-api'
import type { ReviewCustomer } from '@backmarket/http-api/src/api-specs-reviews/types/review'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevCardCarousel } from '@ds/components/CardCarousel'
import { RevIllustration } from '@ds/components/Illustration'
import { RevRating } from '@ds/components/Rating'
import { RevTag } from '@ds/components/Tag'

import BlockTitle from '../../shared-components/BlockTitle/BlockTitle.vue'

import translations from './Reviews.translations'

export type Review = {
  product: {
    title: string
    link: Link
    imageUrl: string
  }
  customer: ReviewCustomer
  reviewPictureUrl: string
  id: string
  comment: string
  averageRate: number
}
defineProps<{
  title: string
  subtitle?: string
  reviews: Review[]
}>()

const i18n = useI18n()
</script>
